// extracted by mini-css-extract-plugin
module.exports = {"banner":"vernacular-cohort-browse-banner_banner__uwr56"};